<template>
  <div
    class="search-filters text-EXPONDO-grey"
  >
    <SearchFiltersHeader />
    <SideCategories v-if="showSideCategories" />
    <SearchFiltersBody class="mt-5" />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'SearchFilters',

  setup() {

    const { isOnSearchPage } = useIsPage();
    const { isNewCategoryTree } = useCategories();

    const showSideCategories = computed(() => !isOnSearchPage.value && !isNewCategoryTree.value);

    return {
      showSideCategories,
    };
  
  },
});

</script>
